import { apiCall } from "./auth";
import { API_URL } from "./config";



export const addinventory = (data) => apiCall(`${API_URL}inventory/addInventory`, "POST",data)
export const upateInventory = (data) => apiCall(`${API_URL}inventory/upateInventory`, "POST",data);
export const getinventory = () => apiCall(`${API_URL}inventory/getallInventory`, "GET")
export const getinventorybyid = (data) => apiCall(`${API_URL}inventory/getinventorybyid`, "POST",data)
export const deleteInventoryApi = (data) => apiCall(`${API_URL}inventory/deleteInventory`, "POST",data)
export const getInventoryByType = (data) => apiCall(`${API_URL}inventory/getInventoryByType`, "POST",data)
export const getModeldatabymake = (data) => apiCall(`${API_URL}inventory/getModeldatabymake`, "POST",data);
export const getbrands = () => apiCall(`${API_URL}inventory/getbrands`, "GET");
export const addbranddata = (data) => apiCall(`${API_URL}inventory/addbranddata`, "POST",data);
export const getitemcetogory = () => apiCall(`${API_URL}inventory/getitemcetogory`, "GET",);
export const getsearchdata = (data) => apiCall(`${API_URL}inventory/getsearchdata`, "POST",data);
export const getInventoryByTypeWithShaftAndGrip = (data) => apiCall(`${API_URL}inventory/getInventoryByTypeWithShaftAndGrip`, "POST",data)
export const getallModeldatabymake = (data) => apiCall(`${API_URL}inventory/getallModeldatabymake`, "POST",data);
export const adddatatoprescriptionapi = (data) => apiCall(`${API_URL}prescription/addremotedatatoprescription`, "POST",data);
export const addorderdata = (data) => apiCall(`${API_URL}orders/create-order`, "POST",data);
export const getorderbyid = (data) => apiCall(`${API_URL}orders/getorderbyid`, "POST",data);
export const updateOrder = (data) => apiCall(`${API_URL}orders/updateOrder`, "POST",data);
export const deletedorder = (data) => apiCall(`${API_URL}orders/deletedorder`, "POST",data);